import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Check if we're on a recording page - if so, don't use StrictMode
const isRecordingPage = window.location.pathname.startsWith('/record/');

if (isRecordingPage) {
  // For recording pages, render without StrictMode to avoid double mounting issues
  root.render(
    <BrowserRouter>
      <App />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            theme: {
              primary: '#4aed88',
            },
          },
        }}
      />
    </BrowserRouter>
  );
} else {
  // For all other pages, use StrictMode as normal
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              theme: {
                primary: '#4aed88',
              },
            },
          }}
        />
      </BrowserRouter>
    </React.StrictMode>
  );
}